/**
 * This code is the intellectual property of Bulb Inc. and other software publishers;
 * it may not be altered, copied or disclosed without prior written approval.
 * Copyright 2025, Bulb Inc. For more information, please email contact@hellobulb.com.
 */

import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { DragDropModule } from 'primeng/dragdrop';
import { TranslocoPipe } from '@jsverse/transloco';
import { GroupHttpService } from './group.service';
import { PinnedUnitsComponent } from './pinned-units/pinned-units.component';
import { UpgradedBlockComponent } from './legacy-block/upgraded-block.component';

@NgModule({
  declarations: [
    PinnedUnitsComponent,
    UpgradedBlockComponent,
  ],
  imports: [
    CommonModule,
    FormsModule,
    DragDropModule,
    TranslocoPipe,
  ],
  providers: [
    GroupHttpService,
  ],
  exports: [
    PinnedUnitsComponent,
    UpgradedBlockComponent,
  ],
})
export class GroupModule { }
